<div class="business-navbar__location-selector__wrapper"
     *ngIf="(interactable$ | async); else noOtherLocations">
    <atlas-item interactable (click)="showSwitchLocationDialog()"
                class="business-navbar__location-selector__business-info"
                [class.business-navbar__location-selector--loaded]="currentLocationName$ | async">
        <ng-content *ngTemplateOutlet="locationSelector"></ng-content>
    </atlas-item>
</div>

<ng-template #noOtherLocations>
    <atlas-item class="business-navbar__location-selector__business-info"
                [class.business-navbar__location-selector--loaded]="currentLocationName$ | async">
        <ng-content *ngTemplateOutlet="locationSelector"></ng-content>
    </atlas-item>
</ng-template>

<ng-template #locationSelector>
    <div *ngIf="currentLocationName$ | async" class="business-navbar__location-selector__container">
        <i class="material-icons business-navbar__location-selector__icon" *ngIf="showIcon$ | async">store</i>
        <div class="business-navbar__location-selector__text">
            <div class="business-navbar__location-selector__business-name-container">
                <span class="business-navbar__location-selector__business-name">{{ currentLocationName$ | async }}</span>
                <i class="material-icons business-navbar__location-selector__dropdown-arrow" *ngIf="interactable$ | async">arrow_drop_down</i>
            </div>
            <span class="business-navbar__location-selector__business-address">{{ currentLocationAddress$ | async }}</span>
        </div>
    </div>
</ng-template>
